var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131258)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.370117,
    y: 0.227539,
    width: 36.0651,
    height: 36.0651,
    rx: 18.0325,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3572 11.7959H15.1272C13.3656 11.7959 11.9375 13.224 11.9375 14.9856V22.2156C11.9375 23.9773 13.3656 25.4054 15.1272 25.4054H22.3572C24.1189 25.4054 25.547 23.9773 25.547 22.2156V14.9856C25.547 13.224 24.1189 11.7959 22.3572 11.7959Z",
    fill: "url(#paint0_linear_659_131258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3572 11.7959H15.1272C13.3656 11.7959 11.9375 13.224 11.9375 14.9856V22.2156C11.9375 23.9773 13.3656 25.4054 15.1272 25.4054H22.3572C24.1189 25.4054 25.547 23.9773 25.547 22.2156V14.9856C25.547 13.224 24.1189 11.7959 22.3572 11.7959Z",
    fill: "url(#paint1_linear_659_131258)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7425 13.2847C17.2987 13.2847 17.1175 13.291 16.5504 13.3168C15.9845 13.3427 15.5981 13.4323 15.2601 13.5638C14.9104 13.6995 14.6138 13.8812 14.3184 14.1768C14.0226 14.4723 13.841 14.7689 13.7048 15.1184C13.5729 15.4565 13.4832 15.843 13.4578 16.4087C13.4324 16.9758 13.4258 17.1571 13.4258 18.6009C13.4258 20.0447 13.4322 20.2254 13.4579 20.7924C13.4839 21.3584 13.5735 21.7447 13.7049 22.0827C13.8408 22.4324 14.0224 22.729 14.318 23.0245C14.6134 23.3202 14.91 23.5023 15.2594 23.6381C15.5977 23.7695 15.9841 23.8591 16.55 23.8851C17.117 23.9108 17.2981 23.9172 18.7418 23.9172C20.1858 23.9172 20.3664 23.9108 20.9334 23.8851C21.4994 23.8591 21.8861 23.7695 22.2244 23.6381C22.5739 23.5023 22.8701 23.3202 23.1655 23.0245C23.4612 22.729 23.6428 22.4324 23.7791 22.0829C23.9097 21.7447 23.9995 21.3583 24.0261 20.7925C24.0515 20.2255 24.0582 20.0447 24.0582 18.6009C24.0582 17.1571 24.0515 16.9759 24.0261 16.4088C23.9995 15.8429 23.9097 15.4566 23.7791 15.1186C23.6428 14.7689 23.4612 14.4723 23.1655 14.1768C22.8698 13.8811 22.5741 13.6994 22.2241 13.5638C21.8852 13.4323 21.4986 13.3427 20.9327 13.3168C20.3656 13.291 20.1851 13.2847 18.7408 13.2847H18.7425ZM18.2655 14.2427C18.4071 14.2425 18.5651 14.2427 18.7425 14.2427C20.1619 14.2427 20.3301 14.2478 20.8907 14.2733C21.409 14.297 21.6903 14.3836 21.8777 14.4564C22.1258 14.5527 22.3027 14.6679 22.4887 14.854C22.6747 15.0401 22.7899 15.2173 22.8865 15.4654C22.9593 15.6525 23.046 15.9338 23.0696 16.4522C23.095 17.0126 23.1006 17.1809 23.1006 18.5997C23.1006 20.0185 23.095 20.1868 23.0696 20.7472C23.0459 21.2656 22.9593 21.5469 22.8865 21.7341C22.7902 21.9822 22.6747 22.1588 22.4887 22.3448C22.3026 22.5309 22.126 22.646 21.8777 22.7424C21.6906 22.8155 21.409 22.9019 20.8907 22.9256C20.3302 22.9511 20.1619 22.9566 18.7425 22.9566C17.3229 22.9566 17.1547 22.9511 16.5943 22.9256C16.076 22.9017 15.7946 22.8151 15.6071 22.7423C15.359 22.6459 15.1818 22.5308 14.9957 22.3447C14.8096 22.1586 14.6945 21.9819 14.5979 21.7336C14.5251 21.5465 14.4384 21.2651 14.4148 20.7468C14.3893 20.1864 14.3842 20.0181 14.3842 18.5984C14.3842 17.1787 14.3893 17.0113 14.4148 16.4508C14.4385 15.9325 14.5251 15.6512 14.5979 15.4638C14.6943 15.2157 14.8096 15.0385 14.9958 14.8524C15.1818 14.6663 15.359 14.5511 15.6071 14.4546C15.7945 14.3815 16.076 14.2951 16.5943 14.2713C17.0847 14.2491 17.2748 14.2425 18.2655 14.2414V14.2427ZM21.5802 15.1254C21.228 15.1254 20.9423 15.4109 20.9423 15.7631C20.9423 16.1153 21.228 16.4011 21.5802 16.4011C21.9324 16.4011 22.2182 16.1153 22.2182 15.7631C22.2182 15.4109 21.9324 15.1252 21.5802 15.1252V15.1254ZM18.7425 15.8708C17.2348 15.8708 16.0124 17.0932 16.0124 18.6009C16.0124 20.1086 17.2348 21.3305 18.7425 21.3305C20.2502 21.3305 21.4722 20.1086 21.4722 18.6009C21.4722 17.0932 20.2501 15.8708 18.7424 15.8708H18.7425ZM18.7425 16.8288C19.7211 16.8288 20.5146 17.6222 20.5146 18.6009C20.5146 19.5796 19.7211 20.373 18.7425 20.373C17.7637 20.373 16.9704 19.5796 16.9704 18.6009C16.9704 17.6222 17.7637 16.8288 18.7425 16.8288Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131258",
    x: -4.62988,
    y: -4.77246,
    width: 46.0654,
    height: 46.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131258"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131258",
    result: "effect2_innerShadow_659_131258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131258",
    x1: 18.7422,
    y1: 9.34619,
    x2: 18.7422,
    y2: 27.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_659_131258",
    x1: 18.7422,
    y1: 9.34619,
    x2: 18.7422,
    y2: 27.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstas);
export default __webpack_public_path__ + "static/media/instas.7e97cc51384ff041584be3aa441e68c4.svg";
export { ForwardRef as ReactComponent };